import { EmptyState } from "./EmptyState"

// Generic card-grid alternative to DataTable's rows. A page passes its own
// `renderItem` so the grid stays data-shape-agnostic — Orders renders an
// order/group summary card, a future Vendors page would render a vendor
// card, etc. Selection, sorting and grouping stay the table's job; this is
// deliberately just a layout + empty state.
export const CardGrid = ({ items = [], renderItem, rowKey = (item, i) => item.id ?? item.key ?? i, empty }) => {
  if (items.length === 0) {
    return empty || <EmptyState title="Nothing here yet." />
  }
  return (
    <div className="ds-card-grid">
      {items.map((item, i) => (
        <div key={rowKey(item, i)}>{renderItem(item)}</div>
      ))}
    </div>
  )
}

export default CardGrid
